import { Box, HStack, Text } from '@chakra-ui/react';
import { SvgIcon } from 'core/ui-next';
import * as Images from '../Images';

import React from 'react';

export function FingerprintReaderStatus({ enabled, message }: { enabled: boolean, message: string }) {

	return enabled
		? <Box bg='primary.lighten' borderTopColor='info' borderTopWidth={'thick'}>
			<HStack padding={'2'} lineHeight={'120%'} color={'secondary'}>
				<SvgIcon src={Images.FingerPrint} w={'6'} h={'6'} /><Text fontSize={'xs'} fontWeight={'semibold'}>{message}</Text>
			</HStack>
		</Box>
		: null;
}